module.exports = __webpack_public_path__ + "static/img/slider-3.f369e452.png";